var map = {
	"./audio.png": "5727",
	"./doc.png": "10e7",
	"./image.png": "4437",
	"./mp4.png": "71af",
	"./pdf.png": "5acf",
	"./ppt.png": "7fc0",
	"./txt.png": "c9ca",
	"./unknown.png": "1876",
	"./video.png": "38f1",
	"./visio.png": "00e2",
	"./xls.png": "c31d",
	"./zip.png": "2222"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7c6";